export default __webpack_public_path__ + "static/media/coffee-servant.a15fa29d.svg";